/* Cart gift guard: removes free gifts whose required products are no longer
   in the cart. Rules come from the `ctr_gift_rule` metaobject, rendered as
   JSON by snippets/ctr-gift-guard.liquid. Gifts are matched by product id,
   not by line properties, so lines added without `_ctr_gift` still count.
   Runs on page load, after every cart update and before checkout (via
   recurring-bridge.js). */
(function () {
  var SOURCE = 'ctr-gift-guard';
  var rulesEl = document.getElementById('CtrGiftRules');
  if (!rulesEl) return;

  var rules;
  try {
    rules = JSON.parse(rulesEl.textContent);
  } catch (e) {
    return;
  }
  if (!Array.isArray(rules) || !rules.length) return;

  var running = null;

  function isMet(rule, items, giftIds) {
    var count = items.reduce(function (sum, item) {
      if (giftIds.indexOf(item.product_id) !== -1) return sum;
      return rule.required.indexOf(item.product_id) !== -1 ? sum + item.quantity : sum;
    }, 0);
    return count >= (parseInt(rule.min, 10) || 1);
  }

  /* Keys of gift lines with no met rule. A gift can have several rules (e.g.
     offered by different PDPs); one met rule keeps it. Gift lines never count
     toward a requirement. */
  function invalidGiftKeys(cart) {
    var items = (cart && cart.items) || [];
    var giftIds = rules.map(function (r) { return r.gift; });

    return items
      .filter(function (item) {
        var giftRules = rules.filter(function (r) { return r.gift === item.product_id; });
        return giftRules.length && !giftRules.some(function (r) { return isMet(r, items, giftIds); });
      })
      .map(function (item) { return item.key; });
  }

  function getSections() {
    var sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } })
    );
    /* Before cart.js defines its elements nobody answers the event: read the
       section ids from the DOM so the guard's update still re-renders. */
    if (!sections.length) {
      document.querySelectorAll('cart-drawer, main-cart').forEach(function (el) {
        var id = FoxTheme.utils.getSectionId(el);
        if (id) sections.push(id);
      });
    }
    return sections;
  }

  function fetchCart() {
    return fetch(FoxTheme.routes.cart_url + '.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function removeLines(keys) {
    var updates = {};
    keys.forEach(function (key) { updates[key] = 0; });
    var sections = getSections();

    return fetch(FoxTheme.routes.cart_update_url, {
      ...FoxTheme.utils.fetchConfig(),
      body: JSON.stringify({ updates: updates, sections: sections })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && !cart.status) {
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart, source: SOURCE });
        }
        return cart;
      });
  }

  function clean(cart) {
    var keys = invalidGiftKeys(cart);
    return keys.length ? removeLines(keys) : cart;
  }

  /* Resolves once the cart is clean. A call during a run re-checks the
     fresh cart after it, so no update is missed. */
  function check(cart) {
    if (running) {
      return running.then(function () { return check(); });
    }
    running = (cart && cart.items ? Promise.resolve(cart) : fetchCart())
      .then(clean)
      .then(function (result) {
        /* 422 when a line changed meanwhile: retry once on a fresh cart. */
        return result && result.status ? fetchCart().then(clean) : result;
      })
      .catch(function (error) {
        console.error('Gift guard:', error);
      })
      .finally(function () {
        running = null;
      });
    return running;
  }

  /* Run before the cartUpdate subscribers rather than among them: publish
     has no per-subscriber try/catch, so a throwing subscriber (e.g. a
     re-render hitting a null section) would skip the guard. Subscriber
     order also changes as cart elements re-render and re-subscribe. */
  var publish = FoxTheme.pubsub.publish;
  FoxTheme.pubsub.publish = function (eventName, data) {
    if (eventName === FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate && data && data.source !== SOURCE) {
      /* Some publishers send the /cart/change.js response, others /cart.js;
         both carry items with product_id and key. */
      check(data.cart);
    }
    return publish.apply(this, arguments);
  };

  /* Checkout: recurring-bridge.js holds checkout clicks and awaits this
     before replaying them, so there's a single click interceptor. */
  window.CtrGiftGuard = { check: function () { return check(); } };

  /* Cart state may be stale when returning to the store (back button, new tab). */
  FoxTheme.DOMready(function () { check(); });
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) check();
  });
})();
